/* DWS v1: continuous scroll on catalogue pages (sections/dws-main-collection.liquid).
   Near the end of the list, the next page is fetched through the Section Rendering API and its rows are
   appended to the same list, so the trade steppers and the docked basket keep working (dws-order-pad.js
   listens on the whole catalogue, not on each row). Without JavaScript the Previous/Next links remain. */
(() => {
  const list = document.querySelector('[data-dws-infinite]');
  if (!list || !('IntersectionObserver' in window) || !window.fetch) return;
  const rowsEl = list.querySelector('[data-dws-rows]');
  const sentinel = list.querySelector('[data-dws-more]');
  const pages = list.querySelector('.dws-cat__pages');
  let next = list.dataset.next;
  if (!rowsEl || !sentinel || !next) return;

  if (pages) pages.hidden = true;
  sentinel.hidden = false;
  let loading = false;

  const stop = (showLinks) => {
    observer.disconnect();
    sentinel.hidden = true;
    if (showLinks && pages) pages.hidden = false;
  };

  const load = async () => {
    if (loading || !next) return;
    loading = true;
    try {
      const url = new URL(next, window.location.origin);
      url.searchParams.set('section_id', list.dataset.sectionId);
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      doc.querySelectorAll('[data-dws-rows] > *').forEach((row) => rowsEl.appendChild(document.importNode(row, true)));
      const more = doc.querySelector('[data-dws-infinite]');
      next = more ? more.dataset.next : '';
      document.dispatchEvent(new CustomEvent('dws:rows-added'));
    } catch (e) {
      next = '';
      stop(true);
    }
    loading = false;
    if (!next) { stop(false); return; }
    /* Re-arm: an observer only reports changes, so if the end of the list is still in reach, check again. */
    observer.unobserve(sentinel);
    observer.observe(sentinel);
  };

  const observer = new IntersectionObserver((entries) => {
    if (entries.some((e) => e.isIntersecting)) load();
  }, { rootMargin: '900px 0px' });
  observer.observe(sentinel);
})();
